import React, { useState, lazy } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Provider } from "react-redux";
import store from "./redux/store";
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";
import TongQuan from "./pages/TongQuan/TongQuan"; // keep critical landing small (can be lazy-loaded later)

const TiepDon = lazy(() => import("./pages/TiepDon/TiepDon"));
const KhamBenh = lazy(() => import("./pages/KhamBenh/KhamBenh"));
const DonThuoc = lazy(() => import("./pages/KhamBenh/DonThuoc"));
const KhachHang = lazy(() => import("./pages/KhachHang/KhachHang"));
const NhomKhachHang = lazy(() => import("./pages/KhachHang/NhomKhachHang"));
const CanLamSang = lazy(() => import("./pages/CanLamSang/CanLamSang"));
// const SieuAm = lazy(() => import("./pages/CanLamSang/SieuAm"));
// const XetNghiem = lazy(() => import("./pages/CanLamSang/XetNghiem"));
// const NoiSoi = lazy(() => import("./pages/CanLamSang/NoiSoi"));
const NhaThuoc = lazy(() => import("./pages/NhaThuoc/NhaThuoc"));
const QuanLyKho = lazy(() => import("./pages/QuanLyKho/QuanLyKho"));
const KeToan = lazy(() => import("./pages/KeToan/KeToan"));
const BaoCao = lazy(() => import("./pages/BaoCao/BaoCao"));
const BaoCaoKham = lazy(() => import("./pages/BaoCao/BaoCaoKham"));
const BaoCaoKhachHang = lazy(() => import("./pages/BaoCao/BaoCaoKhachHang"));
const BaoCaoBacSi = lazy(() => import("./pages/BaoCao/BaoCaoBacSi"));
const NhanVien = lazy(() => import("./pages/HeThong/NhanVien"));
const PhongBan = lazy(() => import("./pages/HeThong/PhongBan"));
const VaiTro = lazy(() => import("./pages/HeThong/VaiTro"));
const HangHoa = lazy(() => import("./pages/HeThong/HangHoa"));
const DichVu = lazy(() => import("./pages/HeThong/DichVu"));
import MainLayout from "./MainLayout";
import Login from "./pages/Auth/Login";
const NhomHangHoaList = lazy(() => import("./pages/HeThong/NhomHangHoaList"));

import "./styles/main.scss";
const Hoadon = lazy(() => import("./pages/KeToan/Hoadon"));
const CaiDat = lazy(() => import("./pages/HeThong/CaiDat"));
const LienThong = lazy(() => import("./pages/HeThong/LienThong"));
const BaoCaoBanHangDoanhThu = lazy(() => import("./pages/BaoCao/BaoCaoBanHang"));
const BaoCaoNguoiGioiThieu = lazy(() => import("./pages/BaoCao/BaoCaoNguoiGioiThieu"));
const BaoCaoNguoiThucHien = lazy(() => import("./pages/BaoCao/BaoCaoNguoiThucHien"));

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(localStorage.getItem("isLoggedIn") === "true");

  // Custom hook to navigate after login test build
  function LoginWrapper() {
    const navigate = useNavigate();
    const handleLogin = () => {
      setIsLoggedIn(true);
      navigate("/");
    };
    return <Login onLogin={handleLogin} />;
  }

  return (
    <Provider store={store}>
      <Router>
        <Routes>
          {!isLoggedIn && <Route path="*" element={<LoginWrapper />} />}
          {isLoggedIn && (
            <Route element={<MainLayout />}>
              <Route path="/" element={<TongQuan />} />
              <Route path="/tong-quan" element={<TongQuan />} />
              <Route path="/tiep-don" element={<TiepDon />} />
              <Route path="/kham-benh" element={<KhamBenh />} />
              <Route path="/kham-benh/don-thuoc" element={<DonThuoc />} />
              <Route path="/khach-hang" element={<KhachHang />} />
              <Route path="/khach-hang/nhom-khach-hang" element={<NhomKhachHang />} />
              <Route path="/can-lam-sang/*" element={<CanLamSang />} />
              <Route path="/nha-thuoc" element={<NhaThuoc />} />
              <Route path="/quan-ly-kho" element={<QuanLyKho />} />
              <Route path="/ke-toan/thanh-toan" element={<KeToan />} />
              <Route path="/ke-toan/hoa-don" element={<Hoadon />} />
              <Route path="/bao-cao" element={<BaoCao />} />
              <Route path="/bao-cao/kham" element={<BaoCaoKham />} />
              <Route path="/bao-cao/ban-hang" element={<BaoCaoBanHangDoanhThu />} />
              <Route path="/bao-cao/khach-hang" element={<BaoCaoKhachHang />} />
              <Route path="/bao-cao/bac-si" element={<BaoCaoBacSi />} />
              <Route path="/bao-cao/nguoi-gioi-thieu" element={<BaoCaoNguoiGioiThieu />} />
              <Route path="/bao-cao/nguoi-thuc-hien" element={<BaoCaoNguoiThucHien />} />
              <Route path="/he-thong/nhan-vien" element={<NhanVien />} />
              <Route path="/he-thong/phong-ban" element={<PhongBan />} />
              <Route path="/he-thong/vai-tro" element={<VaiTro />} />
              <Route path="/he-thong/hang-hoa" element={<HangHoa />} />
              <Route path="/he-thong/nhom-hang-hoa" element={<NhomHangHoaList />} />
              <Route path="/he-thong/dich-vu" element={<DichVu />} />
              <Route path="/he-thong/lien-thong" element={<LienThong />} />
              <Route path="/he-thong/cai-dat" element={<CaiDat />} />
            </Route>
          )}
        </Routes>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
          toastClassName="toastify-toast"
          bodyClassName="toastify-body"
          style={{ fontFamily: "Roboto, Arial", fontSize: 16 }}
        />
      </Router>
    </Provider>
  );
}

export default App;
